<template>
    <label class="flex flex-col mt-5">
        <span class="font-bold" v-if="label">{{ label }}</span>
        <span class="mt-1">
            <slot />
        </span>
    </label>
</template>

<script>
    export default {
        props: {
            label: {
                required: false,
                type: String,
            }
        }
    };
</script>
